import StarterKit from '@tiptap/starter-kit'
import Link from '@tiptap/extension-link'
import Underline from '@tiptap/extension-underline'

/** TipTap extensions for read-only HTML (no Placeholder). */
export const createBlogRenderExtensions = () => [
  StarterKit.configure({
    heading: { levels: [2, 3, 4] },
  }),
  Underline,
  Link.configure({
    openOnClick: true,
    HTMLAttributes: {
      rel: 'noopener noreferrer',
      target: '_blank',
    },
  }),
]
